module.exports = __webpack_public_path__ + "img/電気回路_2_10_5.3b2ed792.png";